import React from "react";
import $ from "jquery";

export async function makeAsyncRequestCommon({path, type, requestData} = {}) {
    try {
        let answer = await $.ajax({
            type: type,
            url: path,
            data: JSON.stringify(requestData ? requestData : {}),
            contentType: "application/json",
            success: (response) => {
                return response
            },
            error: (response) => {
                return response;
            }
        });

        if (typeof answer === 'string') {
            answer = JSON.parse(answer);
        }

        return answer;
    }  catch (e) {
        return null;
    }
}

export function genGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,
        function(c)
        {
            let r = Math.random() * 16|0, v = c === 'x' ? r : (r&0x3|0x8);
            return v.toString(16);
        });
}

export function copyStringToBuffer(text, onCopyAction) {
    navigator.clipboard.writeText(text).then(() => { onCopyAction() })
}

export function readStringToBuffer(onReadAction) {
    navigator.clipboard.readText().then(text => {
        if (onReadAction) { onReadAction(text); }
    })
}

export function rgbStringToHex(rgbStr) {
    if (rgbStr.startsWith('rgb')) {
        rgbStr = rgbStr.replaceAll('rgb(', '');
        rgbStr = rgbStr.replaceAll(')', '');
        rgbStr = rgbStr.replaceAll(',', '');
        let rgbArr = rgbStr.split(' ');
        return rgbToHex(parseInt(rgbArr[0]), parseInt(rgbArr[1]), parseInt(rgbArr[2]));
    } else {
        return rgbStr;
    }
}

function rgbToHex(red, green, blue) {
    const rgb = (red << 16) | (green << 8) | (blue << 0);
    return '#' + (0x1000000 + rgb).toString(16).slice(1);
}

export function copyObject(object) {
    return JSON.parse(JSON.stringify(object));
}

export function isString(s) {
    return typeof(s) === 'string' || s instanceof String;
}

export function getFromLocalStorage(key) {
    return window.localStorage.getItem(key)
}

export function putToLocalStorage(key, value) {
    window.localStorage.setItem(key, value)
}

export function removeFromLocalStorage(key) {
    window.localStorage.removeItem(key)
}

export function openLinkInNewTab(url) {
    window.open(url, '_blank').focus();
}

export function openLinkInCurrentTab(url) {
    window.open(url,"_self")
}

export function scrollParentToElementCenter(element, parent, duration, onCompleteAction) {
    let elOffset = element.offset().top;
    let elHeight = element.height();
    let parentViewTop = parent.offset().top;
    let parentHeight = parent.innerHeight();
    let offset;
    let margin;

    if (elHeight >= parentHeight) {
        offset = elOffset;
    } else {
        margin = (parentHeight - elHeight)/2;
        offset = elOffset - margin;
    }

    let scrollOffset = parent.scrollTop() + offset - parentViewTop;

    parent.animate({scrollTop:scrollOffset}, duration ? duration : 200, () => onCompleteAction());
}

export function calcObjectHash(obj) {
    return calcHash(JSON.stringify(obj));
}

export function calcHash(strForHash) {
    let hash = 0, i, chr;
    if (strForHash.length === 0) return hash;
    for (i = 0; i < strForHash.length; i++) {
        chr = strForHash.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0;
    }
    return hash;
}

export function getAppName() {
    let packageJson = require('../../../package.json');
    return packageJson ? packageJson.displayName : "";
}

export function getAppYears() {
    return "2021 - 2024";
}

export function getAppVersionNameDiv() {
    return <div id={'appVersionDiv'} className={'appVersionDiv noSelect'}>
        {getAppName() + ', ' + getAppYears()}
    </div>
}

export function getMutaMapeperVersion() {
    let packageJson = require('../../../package.json');
    return packageJson ? packageJson.mutaMapeperVersion : "";
}

export function getMutaMapeperVersionDiv() {
    return <div id={'appVersionDiv'} className={'appVersionDiv noSelect'}>
        {'MutaMapeper' + ' ' + getMutaMapeperVersion() + ', ' + getAppYears()}
    </div>
}

export function changePageTitle(newTitle) {
    document.title = newTitle;
}

export function changePageFavIcon(newIcon) {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
    }
    link.href = newIcon;
}